/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ServiceCompanyRangeDTO {
  daysToDelivery?: number;
  maxGrams?: number;
  minGrams?: number;
  serviceCompanyRangeId?: number;
  shippingCompanyName?: string;
  shippingPrice?: number;
  shippingServiceId?: number;
  state?: string;
  zipEnd?: number;
  zipStart?: number;
}
